import { useEffect } from 'react';
import { useObservable } from './useObservable';
import { sessionQuery, userStaysQuery, userStaysService } from '@lib/state';

export function useGuestRooms() {
  const user = useObservable(sessionQuery.currentUser);
  const guestRooms = useObservable(userStaysQuery.guestRooms);

  useEffect(() => {
    userStaysService.getUserStays();
  }, []);

  return !user ? [] : guestRooms;
}
